<!--
 * @Date: 2020-05-15 13:21:06
 * @LastEditors: 黄栋
 * @LastEditTime: 2020-05-26 15:11:40
 * @FilePath: /xy-pc/src/views/userCenter/myCourse/index.vue
--> 
<template>
  <div class="student_myclass" style="width:100%">
    <el-tabs v-model="activeName" @tab-click="tabClick">
      <el-tab-pane label="普通课程" name="1">
        <NormalList />
      </el-tab-pane>
      <el-tab-pane label="班级课程" name="2">
        <classList />
      </el-tab-pane>
    </el-tabs>
  </div>
</template> 
<script>
import NormalList from "./normalList";
import classList from "./classList";

export default {
  components: { NormalList, classList },
  data() {
    return {
      activeName: "1",
      page: 1,
      limit: 10,
      classlist: [
        {
          id: "", //我的课程id
          course: {
            id: "", //课程ID
            title: "", //课程标题
            expert_name: "", //专家姓名
            price: "", //价格
            score: "", //评分
            chapter_number: "", //总章数
            thumb_image: "", //缩略图
          },
        },
      ],
    };
  },
  created() {
    if (this.$route.query.tab) {
      this.activeName = this.$route.query.tab;
    }
  },
  methods: {
    tabClick() {
      this.page = 1;
    },
  },
};
</script>

<style lang="less" scoped>
</style>